import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import store from "./redux";
import './assets/css/main.css';

import ChatRoom from "./Components/chat";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="/" component={ChatRoom} />
          {/* Chat multi-tenant -- Task 8b: chat.alodesk.com.br/<slug> identifica a
              empresa pelo slug público. "/" (sem slug, produção atual) continua
              funcionando via slug padrão -- ver src/utils/tenant.js. */}
          <Route exact path="/:slug" component={ChatRoom} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
